import type { ErrorComponentProps } from "@tanstack/react-router";
import * as Sentry from "@sentry/react";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

function ErrorPrint({ error, reset }: ErrorComponentProps) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);
  const errorMessage = error instanceof Error ? error.message : String(error);

  return (
    <div className="min-h-svh bg-background text-foreground flex flex-col items-center justify-center p-4 space-y-4">
      <h1 className="text-2xl font-bold text-red-500">服务器错误</h1>
      <p className="text-muted-foreground text-sm">当前页面出现未处理异常，已上报给 Sentry</p>
      <p className="text-xs text-destructive text-center break-words max-w-xl">{errorMessage}</p>
      {reset ? <Button onClick={reset}>重试</Button> : null}
    </div>
  );
}

export default ErrorPrint;
